import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getBillingHistory } from 'modules/settings/api';

export const useQueryBillingHistory = () => {
  const {
    data: billingHistoryData,
    isLoading: billingHistoryLoading,
    isError: billingHistoryError,
    isFetching: billingHistoryIsFetching,
    refetch: billingHistoryRefetch,
  } = useQuery([QUERY_KEYS.SETTINGS_SUBSCRIPTION], getBillingHistory);

  return {
    billingHistoryData,
    billingHistoryLoading,
    billingHistoryError,
    billingHistoryIsFetching,
    billingHistoryRefetch,
  };
};
